import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/Home/Home'
import Faq from '@/pages/Faq/Faq'
import Error from '@/pages/Error/Error'
import Terms from '@/pages/Terms/Terms'
import About from '@/pages/About/About'
import CpfRadarTerms from '@/pages/CpfRadarTerms/CpfRadarTerms'
import CpfRadarPrivacy from '@/pages/CpfRadarPrivacy/CpfRadarPrivacy'


Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [{
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/faq',
      name: 'Faq',
      component: Faq
    },
    {
      path: '/terms',
      name: 'Terms',
      component: Terms
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '*',
      name: 'error',
      component: Error
    },
    {
      path: '/cpf-radar-terms',
      name: 'CpfRadarTerms',
      component: CpfRadarTerms
    },
    {
      path: '/cpf-radar-privacy',
      name: 'CpfRadarPrivacy',
      component: CpfRadarPrivacy
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash
      }
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js